export default __webpack_public_path__ + "static/media/manzil_coin.02026c14.svg";